// extracted by mini-css-extract-plugin
module.exports = {"controls":"a10a3f92e9--controls--2Kmjr","controls--hidden":"a10a3f92e9--controls--hidden--173Fj","single":"a10a3f92e9--single--NYwjX"};